export function meta() {
  return [
    { title: "Linkday — App Dashboard" },
    { name: "description", content: "Linkday connects your CRM with LinkedIn for seamless contact management." },
    { name: "robots", content: "noindex, nofollow" },
  ];
}

export default function Home() {
  return (
    <main style={{
      fontFamily: "ui-sans-serif, system-ui, -apple-system, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "24px",
      textAlign: "center",
      color: "#1f2937",
      background: "#fafafa",
    }}>
      <div style={{ maxWidth: "480px", width: "100%" }}>
        {/* Logo */}
        <img
          src="/logo-light.svg"
          alt="Linkday"
          style={{ height: "36px", margin: "0 auto 32px" }}
        />

        {/* Main message */}
        <h1 style={{ fontSize: "22px", fontWeight: "600", marginBottom: "12px", color: "#111827" }}>
          This is the Linkday app server
        </h1>
        <p style={{ fontSize: "15px", color: "#6b7280", lineHeight: "1.6", marginBottom: "32px" }}>
          This page is not meant for direct access. Linkday works as an integration inside your CRM.
          Install it from your CRM marketplace to get started.
        </p>

        {/* CRM Marketplace buttons */}
        <div style={{ marginBottom: "32px" }}>
          <a
            href="https://monday.com/marketplace/listing/10000607/linkday"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 24px",
              fontSize: "14px",
              fontWeight: "500",
              borderRadius: "8px",
              border: "none",
              background: "#6c47ff",
              color: "#fff",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Install on monday.com
          </a>
          <p style={{ fontSize: "13px", color: "#9ca3af", marginTop: "12px" }}>
            HubSpot, Salesforce, and Pipedrive — coming soon
          </p>
        </div>

        {/* Divider */}
        <div style={{ borderTop: "1px solid #e5e7eb", margin: "0 auto 24px", width: "80%" }} />

        {/* Support */}
        <a
          href="mailto:support@linkday.app"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 20px",
            fontSize: "14px",
            fontWeight: "500",
            borderRadius: "8px",
            border: "1px solid #d1d5db",
            background: "#fff",
            color: "#374151",
            textDecoration: "none",
            cursor: "pointer",
            marginBottom: "24px",
          }}
        >
          Contact Support
        </a>

        {/* Footer links */}
        <div style={{ display: "flex", justifyContent: "center", gap: "24px", fontSize: "13px" }}>
          <a href="https://linkday.app/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "#9ca3af", textDecoration: "none" }}>
            Privacy Policy
          </a>
          <a href="https://linkday.app/terms-of-use" target="_blank" rel="noopener noreferrer" style={{ color: "#9ca3af", textDecoration: "none" }}>
            Terms of Use
          </a>
          <a href="https://linkday.app" target="_blank" rel="noopener noreferrer" style={{ color: "#9ca3af", textDecoration: "none" }}>
            linkday.app
          </a>
        </div>
      </div>
    </main>
  );
}
